// extracted by mini-css-extract-plugin
export default {"disclaimer":"p_bL"};